export default __webpack_public_path__ + "static/media/sample_bulk_registration.2f2e7858.csv";